import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Basic } from 'src/app/core/models/basic.model';
import { MasterService } from 'src/app/services/master.service';
import { DocumentType } from 'src/app/models/master/document-type.model';

@Component({
  selector: 'client-representative-section',
  templateUrl: './client-representative-section.component.html',
  styleUrls: ['./client-representative-section.component.scss']
})
export class ClientRepresentativeSectionComponent implements OnInit {
  /*Lista de tipos de documento */
  documentTypeList: DocumentType[] = [];
  /*Lista de tipos de relaciones */
  relationshipTypeList: Basic<string>[] = [];
  formGroup: FormGroup;
  constructor(private formBuilder: FormBuilder,
    private masterService: MasterService) { }

  ngOnInit() {
    this.createForm();
    this.listDocumentTypes();
    this.listRelationshipTypes();
    this.toggleRepresentativeSection();
  }
  createForm() {
    this.formGroup = this.formBuilder.group({
      includeRepresentativeSection: [false, [Validators.required]],
      data: this.formBuilder.group({
        relationshipType: [, [Validators.required]],
        name: [, [Validators.required]],
        lastName: [, [Validators.required]],
        documentType: [, [Validators.required]],
        documentNumber: [, [Validators.required]],
        homePhone: [],
        cellPhone: [],
        email: [, [Validators.required, Validators.email]]
      // }, { validators: this.atLeastHomePhoneOrCellPhoneValidator })
      }),
    })
  }
  // atLeastHomePhoneOrCellPhoneValidator(abstractControl: AbstractControl) {
  //   if (
  //     (abstractControl.get('cellPhone').value != null
  //       && abstractControl.get('cellPhone').value.toString().trim() != '')
  //     ||
  //     (abstractControl.get('homePhone').value != null
  //       && abstractControl.get('homePhone').value.toString().trim() != '')) {
  //     return null;
  //   } else return { homePhoneOrCellPhoneIsNeeded: true };
  // }
  listRelationshipTypes() {
    this.masterService.listRelationshipTypes().subscribe(response => {
      this.relationshipTypeList = response.data;
    });
  }
  listDocumentTypes() {
    this.masterService.listDocumentTypes().subscribe(response => {
      this.documentTypeList = response.data;
    });
  }
  toggleRepresentativeSection() {
    if (this.formGroup.get('includeRepresentativeSection').value === true) {
      this.formGroup.get('data').enable();
    } else {
      this.formGroup.get('data').disable();
    }
  }
}
